import React, { useEffect, useRef, useState, CSSProperties } from "react";
import { tagColors } from "../../helpers/tagColors";
import "./TagComponent.css";

const TagComponent = ({
  tag,
  isSelected,
  onClick,
  tagsDefaultColors,
  onMouseEnter,
  onMouseLeave,
  tagsCounts = {},
  needCount = false,
  onTagColorChange,
  onTagColorConfigure,
  color = null,
}) => {
  const fallbackColor = tagColors[Math.abs(tag.id) % tagColors.length];
  const [tagColor, setTagColor] = useState(
    color ||
      (tagsDefaultColors && tagsDefaultColors[tag.id]) ||
      tag.color ||
      fallbackColor
  );
  const [contextMenu, setContextMenu] = useState(null); // { x, y } | null

  const tagColorClass = {
    "--tag-color": tagColor,
    "--tag-fill": `color-mix(in srgb, ${tagColor} 15%, transparent)`,
    "--tag-ink": "#12151d",
  };

  useEffect(() => {
    if (color) {
      setTagColor(color);
    } else {
      setTagColor(tagsDefaultColors[tag.id] || tag.color || fallbackColor);
    }
  }, [color, tag.id, tagsDefaultColors]);

  const handleContextMenu = (e) => {
    e.preventDefault();
    setContextMenu({ x: e.clientX, y: e.clientY });
  };

  const handleCloseMenu = () => {
    setContextMenu(null);
  };

  const handleConfigureColor = () => {
    handleCloseMenu();
    if (onTagColorConfigure) {
      onTagColorConfigure(tag);
    }
  };

  const handleClickOutside = (e) => {
    if (contextMenu && e.target.tagName !== "BUTTON") {
      handleCloseMenu();
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [contextMenu]);

  return (
    <>
      <div
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        onContextMenu={handleContextMenu}
        className={`tag-block`}
        style={{ ...tagColorClass }}
        onClick={onClick}
      >
        <span className="tag__bg" />
        <div>
          <span className="tag__label" style={{ ...tagColorClass }}>
            {tag.name}
          </span>
          {needCount && tagsCounts[tag.id] && (
            <span
              className="tag__label"
              style={{ ...tagColorClass, opacity: 0.3 }}
            >
              {` ${tagsCounts[tag.id]}`}
            </span>
          )}
        </div>
      </div>

      {contextMenu && (
        <div
          className="tag-context-menu"
          style={{ left: contextMenu.x, top: contextMenu.y }}
          onMouseLeave={handleCloseMenu}
        >
          <button
            type="button"
            className="tag-context-menu-item"
            onClick={handleConfigureColor}
          >
            Настроить цвет
          </button>
        </div>
      )}
    </>
  );
};

export default TagComponent;
